<template>
    <div @click="closeModal()" class="product-modal">
      <div v-on:click.stop class="product-modal-container no-scrollbar" :class="expanded ? 'expanded' : ''">
        <img @click="closeModal()" class="x" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
        <p class="main-title mobile">{{ product.title }}</p>
          <div class="image-container">
            <VueSlickCarousel v-if="isMobile()" :arrows="false" :dots="true" :slidesToShow="1" :slidesToScroll="1">
                <img 
                    v-for="image in product.images" 
                    :key="image.id"
                    class="main-image"
                    :src="image.src"
                >
            </VueSlickCarousel>
            <img class="main-image desktop" :src="selectedImage"/>
            <div class="extra-images-container">
                <Flicking ref="flicking" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true,renderOnlyVisible: true,horizontal: false }">
                    <img 
                        v-for="image in product.images" 
                        :key="image.id"
                        class="extra-image lazyload"
                        :class="image.src == selectedImage ? 'selected' : ''"
                        :src="image.src"
                        @click="selectImage(image.src)"
                    >
                </Flicking>
            </div>
          </div>
          <div class="information-container">
              <p class="main-title desktop">{{ product.title }}</p>
              <p class="description-label">Description</p>
              <span class="main-description">{{ product | getProductDesc}}</span>
              <div class="ethos-container">
                    <span :class="badgeExtraClass(etho)" v-for="etho in ethosTags" :key="etho">{{etho}}</span>
                </div>
              <p class="grey-legend">This is just one amazing gift in the assortment of items your recipient will be able to choose from! Reminder: they'll never know the value you picked, and no receipts will be in the packaging.</p>
              <button v-if="sendCopy" @click="() => {$emit('changepage')}" class="happybox-button green border">{{ sendCopy }}</button>
          </div>
      </div>
    </div>
  </template>
  
<script>
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    data(){
        return{
            currentImage: null,
            smooth: true,
        }
    },
    props:{
        product: Object,
        sendCopy: String,
    },
    components:{
        VueSlickCarousel
    },
    data(){
        return {
            expanded: false
        }
    },
    computed:{
        selectedImage(){
            if(!this.currentImage){
                return this.product.images[0].src;
            }
            else {
                return this.currentImage;
            }
        },
        ethosTags(){
            if(this.product){
                var ethos = this.product.tags.filter(y => y.includes("Filter_Ethos"));
                ethos = ethos.map((x) => {
                    var currentEthos = x.replace("Filter_","").split("_")
                    return currentEthos[1]
                })
                return ethos;
            }

            return []
        },
    },
    methods:{
        selectImage(src){
            this.currentImage = src;
        },
        closeModal(){
            this.$emit("closemodal");
        },
        isMobile() {
            return window.innerWidth < 768;
        },
        badgeExtraClass(badge){
          switch(badge){
            case "Women Owned":
              return "pink";
            case "Small Biz":
              return "green"
            case "BIPOC Owned":
              return "yellow"
            case "Sustainable":
              return "dgreen"
            case "Admin Professionals Day":
              return "lyellow"
            default:
              return '';
          }
        }
    },
    mounted(){
        this.expanded = true;
    },
  
}
</script>
  
  <style>
    .slick-slider{
        margin-bottom: 0;
    }
    .slick-dots{
        bottom: 15px;
    }
  </style>
  
<style scoped>
    .slick-slider{
        width: 100%;
    }
    .slick-prev:before, .slick-next:before {
        color: black;
        display: none;
    }
    .custom-arrow{
        z-index: 1;
        font-size: 2.5vw;
        color: #000;
        line-height: 1;
    }
    .product-modal{
        background-color: #0000004d!important;
        display: block;
        position: fixed;
        z-index: 99;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        align-items: center;
        padding-top: 90px;
        padding-bottom: 5%;
    }

    .product-modal-container{
        width: 60%;
        max-height: 100%;
        background-color: #fff;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: center;
        align-items: flex-start;
        position: relative;
        border-radius: 20px;
        padding: 3%;
        box-shadow: 0 0 3px #00000050;
    }

    .image-container{
        width: 50%;
        position: relative;
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-end;
        gap: 2%;
        align-items: flex-start;
    }

    .image-container .main-image{
        width: 80%;
    }

    .arrow-right, .arrow-left{
        position: absolute;
        top: 38%;
        font-size: 2.5vw;
        color: #000;
        line-height: 1;
    }

    .arrow-right{
        right: 2%;
    }

    .arrow-left{
        left: 2%;
    }

    .images-slider{
        display: flex;
        position: relative;
        width: 100%;
        padding: 0% 10%;
        margin-top: 5%;
    }

    .images-slider .arrow-left, .images-slider .arrow-right{
        top: 30%;
    }

    .extra-image{
        width: 15%;
        background-color: #f6f6f6;
        cursor: pointer;
        padding: 5%;
    }

    .extra-image.selected{
        border: 1px solid black;
    }

    .information-container{
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        max-height: 100%;
        height: 100%;
    }
  
    .main-title{
        font-size: 2vw;
        color: #0f0c38;
        line-height: 1;
        margin-bottom: 0;
        width: 100%;
        font-weight: bold;
        margin-bottom: 1rem;
    }
  
    .main-description{
        font-size: 1vw;
        color: #0f0c38;
        overflow-y: scroll;
        background-color: #F6F6F6;
        border-radius: 8px;
        padding: 2%;
        min-height: 10vh;
    }

    .information-container .grey-legend{
        color: gray;
        line-height: 1.2;
        font-size: 0.8vw;
        font-style: italic;
        margin-top: 1rem;
    }
  
    .close-container{
        position: absolute;
        top: 1%;
        right: 0%;
        left: 0%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0% 1%;
        align-items: center;
    }
  
    .closeIcon{
        cursor: pointer;
        color: #0f0c38;
        font-size: 1.5vw;
        line-height: 1;
    }
  
    .back{
        cursor: pointer;
        color: #0f0c38;
        font-size: 1.5vw;
        line-height: 1;
        z-index: 1;
        font-weight: bold;
    }
  
    .happybox-button{
        margin-top: 5%;
    }

    .x{
        position: absolute;
        top: 3%;
        right: 3%;
        width: 3%;
        cursor: pointer;
    }

    .description-label{
        margin: unset;
        text-align: left;
        width: 100%;
        font-size: 1.3vw;
        font-weight: bold;
    }

    .ethos-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    padding: 4% 0%;
}

.ethos-container span{
    background-color: white;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1% 3%;
    font-size: 1.1vw;
    font-weight: bold;
    color: #5981d9;
    margin-right: 3%;
}

.ethos-container span.pink{
  background-color: #fbdaff;
}

.ethos-container span.green{
  background-color: #d8efdf;
}

.ethos-container span.yellow{
  background-color: #ffe7c7;
}

.ethos-container span.dgreen{
  background-color: #a9ffbd;
}

.ethos-container span.lyellow{
  background-color: #fffcdd;
}

.ethos-container .purple-ethos{
    background-color: #e3d8f6;
}

.extra-images-container{
    display: flex;
    position: relative;
    width: 15%;
}

.extra-image{
    width: 100%;
    margin-bottom: 0.5rem;
    background-color: #f6f6f6;
    cursor: pointer;
}

.extra-image.selected{
    border: 1px solid black;
}
  
  @media only screen and (max-device-width: 767px){
        .product-modal{
            padding-bottom: unset;
            justify-content: flex-end;
        }

        .product-modal-container{
            width: 100%;
            height: 0%;
            max-height: 100%;
            overflow: scroll;
            flex-direction: column;
            padding: 0%;
            justify-content: flex-start;
            border-bottom-left-radius: unset;
            border-bottom-right-radius: unset;
            transition: height 1s;
        }

        .product-modal-container.expanded{
            height: 100%;
            padding: 7% 5%;
        }
    
        .close-container{
            position: absolute;
            top: 1%;
            padding: 0% 5%;
            z-index: 1;
        }
    
        .closeIcon{
            font-size: 6vw;
        }
    
        .back{
            font-size: 3.5vw;
        }
    
        .image-container{
            width: 100%;
            height: unset;
        }
    
        .arrow-right, .arrow-left{
            top: 45%;
            font-size: 6.5vw;
        }
    
        .information-container{
            margin-top: 4%;
            width: 100%;
            height: 38%;
            text-align: center;
        }
    
        .main-title{
            font-size: 6vw;
            text-align: center;
            margin-bottom: 1rem;
        }
    
        .main-description{
            font-size: 3vw;
            margin-right: unset;
            max-height: 63%;
            overflow-y: scroll;
            margin-top: unset;
        }

        .description-label{
            font-size: 3.5vw;
        }
    
        .custom-arrow{
            font-size: 6vw;
        }
        .images-slider{
            display: none;
        }

        .information-container .grey-legend{
            font-size: 2.5vw;
        }

        .x{
            top: 1%;
            right: 3%;
            width: 7%;
        }

        .ethos-container span{
            font-size: 3vw;
        }

        .extra-images-container{
            display: none;
        }
  }
  
  </style>